import { NavMarker } from 'react-rhumb';
import { Redirect } from 'quartz-routing/react-router';
import LessonOverviewModalContainer from '../../../containers/LessonsPage/LessonOverviewModalContainer';
import TrackOverviewModalContainer from '../../../containers/TracksPage/TrackOverviewModalContainer';
import { NextPlaylistContent } from './NextPlaylistContent';
import { usePlaylistIdFromSearch } from '../hooks';
import { getShortContentUrl } from '../../shortContent/shortContentRouting';
import { jsx as _jsx } from "react/jsx-runtime";
export const NextPlaylistContentOverview = ({
  trackId,
  lessonId,
  shortId,
  navMarkerName
}) => {
  const playlistId = usePlaylistIdFromSearch();
  const content = /*#__PURE__*/_jsx(NextPlaylistContent, {
    lessonId: lessonId,
    render: ({
      trackId: nextTrackId,
      lessonId: nextLessonId,
      shortId: nextShortId,
      language: nextItemLanguage
    }) => {
      if (!nextTrackId && !nextLessonId && !nextShortId) return null;

      // Skip the overview modal in playlist context — go straight to next content
      if (playlistId) {
        if (nextShortId) {
          return /*#__PURE__*/_jsx(Redirect, {
            to: getShortContentUrl({
              shortId: nextShortId,
              playlistId
            })
          });
        }
        return /*#__PURE__*/_jsx(Redirect, {
          to: {
            pathname: nextTrackId ? `/tracks/${nextTrackId}` : `/lessons/${nextLessonId}`,
            search: `?language=${nextItemLanguage.toUpperCase()}&playlistId=${playlistId}`
          }
        });
      }
      if (nextTrackId) {
        return /*#__PURE__*/_jsx(TrackOverviewModalContainer, {
          isPlaylistOverview: true,
          language: nextItemLanguage,
          trackId: nextTrackId
        });
      } else if (nextLessonId) {
        return /*#__PURE__*/_jsx(LessonOverviewModalContainer, {
          isPlaylistOverview: true,
          language: nextItemLanguage,
          lessonId: nextLessonId
        });
      }
      return null;
    },
    shortId: shortId,
    trackId: trackId
  });
  if (navMarkerName) {
    return /*#__PURE__*/_jsx(NavMarker, {
      name: navMarkerName,
      children: content
    });
  }
  return content;
};